/**
 * PWA: registra el SW y busca actualizaciones al abrir o volver a la app.
 * En móvil el service worker solo funciona en contexto seguro (HTTPS o localhost).
 */
export function register() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  if (!window.isSecureContext) {
    if (process.env.NODE_ENV === "development") {
      console.info(
        "[PWA] Sin service worker: la URL no es segura (usa https:// o localhost). " +
          "Desde el celular por Wi‑Fi, publica el build con HTTPS o un túnel (ngrok, etc.)."
      );
    }
    return;
  }

  const allowSw =
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_ENABLE_SW === "true";

  if (!allowSw) {
    return;
  }

  let skipReloadOnNextController = !navigator.serviceWorker.controller;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (skipReloadOnNextController) {
      skipReloadOnNextController = false;
      return;
    }
    window.location.reload();
  });

  window.addEventListener("load", () => {
    const publicBase = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
    const swPath = `${publicBase}/sw.js`.replace(/\/{2,}/g, "/") || "/sw.js";
    const swUrl = new URL(swPath, window.location.origin).href;

    navigator.serviceWorker
      .register(swUrl, { scope: `${publicBase}/`.replace(/\/{2,}/g, "/") || "/" })
      .then((registration) => {
        const checkForUpdate = () => registration.update().catch(() => {});

        checkForUpdate();
        window.addEventListener("pageshow", checkForUpdate);
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") checkForUpdate();
        });

        if (registration.waiting && navigator.serviceWorker.controller) {
          window.location.reload();
        }
      })
      .catch(() => {
        /* registro fallido: sitio sigue sin modo offline */
      });
  });
}
